const tracked = new WeakSet<HTMLElement>();

/**
 * Publishes a callout card's own height as `--ch` on it, and keeps it current as the card changes
 * (text wrapping, the editor's resizable text box). The card's CSS uses it to stop its top where the
 * whole card still fits inside the screen: all the way to the bottom, never hanging off the edge.
 * Used as a callback ref, so it is safe to call on every render.
 */
export function trackCardHeight(el: HTMLElement | null) {
  if (!el || tracked.has(el)) return;
  tracked.add(el);
  const set = () => el.style.setProperty("--ch", `${el.offsetHeight}px`);
  set();
  if (typeof ResizeObserver !== "undefined") new ResizeObserver(set).observe(el);
}
